import React from 'react'
import PropTypes from 'prop-types'
import { Table, ProgressBar, Pagination } from 'react-bootstrap'
import { getBarStyle } from '../../utils'

class StudentTable extends React.Component {
  render() {
    let component = this
    let rows = []
    this.props.analytics.forEach(function (ea) {
      let parasPercentRound = Math.round(ea.paras_percent * 10) / 10
      let videosPercentRound = Math.round(ea.videos_percent * 10) / 10
      let activitiesPercentRound = Math.round(ea.activities_percent * 10) / 10
      let meanActivitiesPercentRound =
        Math.round(ea.mean_activities_percent * 10) / 10
      rows.push(
        <tr key={ea.user_id}>
          <td>
            <a
              href={`/course/progress/${component.props.coursenum}/${ea.user_id}/root/`}
            >
              {ea.last_name}, {ea.first_name}
            </a>
          </td>
          <td>
            <ProgressBar
              now={parasPercentRound}
              label={`${parasPercentRound}%`}
              bsStyle={getBarStyle(parasPercentRound)}
            />
          </td>
          <td>
            <ProgressBar
              now={videosPercentRound}
              label={`${videosPercentRound}%`}
              bsStyle={getBarStyle(videosPercentRound)}
            />
          </td>
          <td>
            <ProgressBar
              now={activitiesPercentRound}
              label={`${activitiesPercentRound}%`}
              bsStyle={getBarStyle(activitiesPercentRound)}
            />
          </td>
          <td>
            <ProgressBar
              now={meanActivitiesPercentRound}
              label={`${meanActivitiesPercentRound}%`}
              bsStyle={getBarStyle(meanActivitiesPercentRound, false)}
            />
          </td>
        </tr>
      )
    })
    let pagination =
      this.props.totalPages > 1 ? (
        <Pagination
          prev="« Prev"
          next="Next »"
          ellipsis
          boundaryLinks
          items={this.props.totalPages}
          maxButtons={10}
          activePage={this.props.activePage}
          onSelect={this.props.handlePageChange}
        />
      ) : (
        <span />
      )
    return (
      <div className="student_table_container">
        {pagination}
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('student')
                }}
              >
                Student
              </th>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('reading')
                }}
              >
                Total Reading Completion
              </th>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('video')
                }}
              >
                Total Video Completion
              </th>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('assessment')
                }}
              >
                Total Assessment Completion
              </th>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('avgAssessment')
                }}
              >
                Average Assessment Performance
              </th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
        {pagination}
      </div>
    )
  }
}

StudentTable.propTypes = {
  analytics: PropTypes.array,
  coursenum: PropTypes.string,
  totalPages: PropTypes.number,
  activePage: PropTypes.number,
  handlePageChange: PropTypes.func,
  handleTableFilterChange: PropTypes.func,
}

export default StudentTable
